import type { ReactNode } from 'react';
import { CARD, CARD_FOOT, CARD_LIFT, cx, SECTION_LABEL } from './classes.js';

export function Card({
  children,
  lift = false,
  className,
  label,
}: {
  children: ReactNode;
  lift?: boolean;
  className?: string;
  label?: string;
}) {
  return (
    <section aria-label={label} className={cx(lift ? CARD_LIFT : CARD, className)}>
      {children}
    </section>
  );
}

/** The quiet source line at the foot of a card ("Source: PACRA, read …"). */
export function CardFoot({ children }: { children: ReactNode }) {
  return <div className={CARD_FOOT}>{children}</div>;
}

/** Card heading row ("Your recent records"). */
export function CardHead({ children }: { children: ReactNode }) {
  return (
    <div className="px-5 py-4 text-[13px] font-semibold tracking-[0.02em] text-mute">
      {children}
    </div>
  );
}

export function SectionLabel({ children }: { children: ReactNode }) {
  return <div className={SECTION_LABEL}>{children}</div>;
}
